module.exports = __webpack_public_path__ + "static/stack-magazine-7e443a5fd3b75f48c0d324a28de2e607.png";